module.exports = __webpack_public_path__ + "static/media/Erasmus-webinar.a4354e23.jpg";